import type { PayloadAction } from "@reduxjs/toolkit"
import { createAppSlice } from "../createAppSlice"
import { MSGraphUser } from "../msgraphapi/graphService"
import { RootState } from "../store"
import { AppRole, AppUserAccount } from "../accountService"



export interface authSliceState {
    msGraphUser?: MSGraphUser
    profilePicture?: string
    userDesignation?: string
    appUserAccount?: AppUserAccount,
    isImpersonating?: boolean,
    appUserRoles?: AppRole[]
}

const initialState: authSliceState = {
    profilePicture: "",
    userDesignation: "",
}
export const authSlice = createAppSlice({
    name: "auth",
    initialState,
    reducers: create => ({
        setMsGraphUser: create.reducer((state, action: PayloadAction<MSGraphUser>) => {
            state.msGraphUser = action.payload
        }),
        setProfilePicture: create.reducer((state, action: PayloadAction<string | undefined>) => {
            state.profilePicture = action.payload
        }),
        setUserDesignation: create.reducer((state, action: PayloadAction<string | undefined>) => {
            state.userDesignation = action.payload
        }),
        setAppUserAccount: create.reducer((state, action: PayloadAction<AppUserAccount>) => {
            state.appUserAccount = action.payload
        }),
        setIsImpersonating: create.reducer((state, action: PayloadAction<boolean>) => {
            state.isImpersonating = action.payload
        }),
        setUserRoles: create.reducer((state, action: PayloadAction<AppRole[] | undefined>) => {
            state.appUserRoles = action.payload
        })
    })
})


export const selectResourceId = (state : RootState) => state.auth.appUserAccount?.data?.resourceId;
export const selectProfilePicture = (state : RootState) => state.auth.profilePicture;
export const selectUserDesignation = (state : RootState) => state.auth.userDesignation || state.auth.msGraphUser?.jobTitle || "";
export const selectUserName = (state: RootState) => {
    const accountName = state.auth.appUserAccount?.name ?? state.auth.appUserAccount?.data?.name
    const graphName = state.auth.msGraphUser?.givenName ?? state.auth.msGraphUser?.displayName

    // Prefer impersonated account name when available, but never return null.
    return (state.auth.isImpersonating ? accountName : graphName) ?? accountName ?? graphName
}
export const selectEmail = (state : RootState) =>
    state.auth.appUserAccount?.data?.emailId ||
    state.auth.appUserAccount?.data?.email ||
    state.auth.appUserAccount?.emailId ||
    state.auth.appUserAccount?.email ||
    state.auth.msGraphUser?.mail ||
    state.auth.msGraphUser?.userPrincipalName;
export const selectRole = (state : RootState) =>
    state.auth.appUserRoles ||
    state.auth.appUserAccount?.data?.permissions?.roles ||
    state.auth.appUserAccount?.permissions?.roles ||
    [];
export const userStatus = (state : RootState) => state.auth.appUserAccount?.data?.status;
export const selectPermissions = (state : RootState) => state.auth.appUserAccount?.permissions;    
export const selectGrade = (state : RootState) => state.auth.appUserAccount?.data?.grade;


export const {
    setMsGraphUser,
    setProfilePicture,
    setUserDesignation,
    setAppUserAccount,
    setIsImpersonating,
    setUserRoles,
} = authSlice.actions
